import { useRef, useEffect } from 'react'

interface Props {
  src: string
}

const SingleVideo: React.FC<Props> = ({ src }) => {
  const videoRef = useRef<HTMLVideoElement>(null)

  useEffect(() => {
    const videoElement = videoRef.current
    if (!videoElement) {
      return
    }

    const autoPlayObserver = new IntersectionObserver(
      (els) => {
        els.forEach((el) => {
          if (el.isIntersecting && el.intersectionRatio === 1) {
            videoElement.play()
          } else {
            videoElement.pause()
          }
        })
      },
      {
        threshold: 1.0,
      },
    )

    autoPlayObserver.observe(videoElement)

    return () => {
      autoPlayObserver.unobserve(videoElement)
      autoPlayObserver.disconnect()
    }
  }, [])

  return (
    <video
      ref={videoRef}
      playsInline
      className="h-full w-full rounded-[30px]"
      controls
      // auto play / auto play observer only works when video is played manually by the user or when you set it to muted=true... if muted=true, auto play always works
      muted={true}
    >
      <source src={src} />
    </video>
  )
}

export default SingleVideo
